import React from 'react';
import { connect } from 'react-redux';
// Level popup imports
import LevelPopupStart from './Types/start';
import LevelPopupAlmost from './Types/almost';
import LevelPopupNext from './Types/next';
import LevelPopupFinish from './Types/finish';
import LevelPopupGameOver from './Types/gameover';
import LevelPopupType from './Enums';

class LevelPopup extends React.Component {
    render = () => {
        const { levelPopup } = this.props;

        switch(levelPopup.activeType) {
            case LevelPopupType.START: {
                return <LevelPopupStart />;
            }
            case LevelPopupType.ALMOST: {
                return <LevelPopupAlmost />;
            }
            case LevelPopupType.NEXT: {
                return <LevelPopupNext />;
            }
            case LevelPopupType.FINISH: {
                return <LevelPopupFinish />;
            }
            case LevelPopupType.GAMEOVER: {
                return <LevelPopupGameOver />
            }
            default: {
                return <></>;
            }
        }
    }
}

const mapStateToProps = state => ({
    levelPopup: state.levelPopup
});

export default connect(
    mapStateToProps
)(LevelPopup);